import { render } from "./articleDetail.vue?vue&type=template&id=ee890c8e&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"

import "./articleDetail.vue?vue&type=style&index=0&id=ee890c8e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee890c8e"]])

export default __exports__